export default "__VITE_ASSET__CaES7WIM__"